<template>
  <div class="audio-container" ref="audioView">
    <!-- <div class="fuzzy" :style="{background: `url(${img}) center`, backgroundSize: 'cover'}"><div></div></div> -->
    <div class="fuzzy"><glass ref="glass" /></div>
    <div class="audio-content">
      <div class="header">{{ list[currentPlay].track_title | commentFilter }}</div>
      <div class="content">
        <img :class="['joystick', isSpin ? 'start':'']" src="@/assets/audio-joystick.png" >
        <!-- 懒加载容器 -->
        <div v-lazy-container="{ selector: 'img', loading: require('@/assets/audio_default.png') }">
          <!-- 滑动切换 -->
          <slider ref="slider" :options="options" @slide="slide" @swipestart="isSpin = false" @mclick="isSpin = audioType != 0" >
            <slideritem v-for="(item,index) in list" :key="index">
              <div :class="['record', index == currentPlay ? 'start':'']" :style="{animationPlayState: isSpin?'running':'paused' }">
                <img :data-src="item.cover_url_small" crossOrigin="anonymous">
              </div>
            </slideritem>
          </slider>
        </div>
      </div>
      <div class="panel">
        <audio
          ref="audio"
          :src="list[currentPlay].track_source"
          @timeupdate="timeupdate"
          @canplay="canplay"
          @ended="end"
          @waiting="waiting"
          @loadstart="loadstart"
        ></audio>
        <range v-model="progress" :barHeight="3" @change="progressChange" @start="progressStart" />
        <div class="time">
          <span>{{ formatTime(currentTime) }}</span>
          <span>{{ formatTime(duration) }}</span>
        </div>
        <div class="btn">
          <img class="loop" :src="loopMap[loopType]" alt="循环" @click="changeLoop">
          <img class="pre" src="@/assets/audio-pre.png" alt="上一首" @click="pre">
          <img :class="['play', audioType == 1?'loading':0 ]" :src="playMap[audioType]" alt="播放" @click="audioType==0?play(currentPlay):pause()">
          <img class="next" src="@/assets/audio-next.png" alt="下一首" @click="next">
          <img class="menu" src="@/assets/audio-menu.png" alt="目录" @click="popupVisible=true">
        </div>
      </div>
    </div>
    <popup
      v-model="popupVisible"
      position="bottom"
    >
      <div class="popup-container">
        <div class="item-header">播放列表</div>
        <div class="item-list">
          <div :class="['item', key == currentPlay? 'playing': '']" v-for="(item, key) in list" :key="key" @click="menueClick(key)">
            <span>
              {{ key+1 }}.{{ substring(item.track_title, 18 ,true) }}
            </span>
            <img src="@/assets/lock.png" v-if="!item.track_source" >
          </div>
        </div>
        <div class="item-foot" @click="popupVisible=false">关闭</div>
      </div>
    </popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Range from '@/components/progress/index';
import { formatTime, substring, inBaiduBrowser } from '@/utils/index'
import { Popup } from 'mint-ui';
import Glass from '@/components/glass/index'
import { slideritem } from 'vue-concise-slider'
import slider from './caudio/slider.js'
import { addHistory, getHistoryForId, deleteHistory } from '../../history/models/storage'
import { isAndroidOrIos } from '@/utils/index'
import { report } from '@/api/flow'
export default {
  name: 'maudio',
  components: {
    Range,
    Popup,
    Glass,
    slider,
    slideritem
  },
  computed: {
    ...mapState({
      audiolist: state => state.audiolist
    })
  },
  filters: {
    commentFilter(comment) {
      return substring(comment, 10, true)
    }
  },
  data () {
    return {
      progress: 0,
      currentTime: 0,
      duration: 0,
      isFast: false,
      isSpin: false,
      audioType: 0,
      playMap:[
        require('@/assets/audio-flay.png'),
        require('@/assets/audio-load.png'),
        require('@/assets/audio-pause.png')
      ],
      currentPlay: 0,
      loopType: 0,
      loopMap: [
        require('@/assets/audio-asc.png'), // 整体循环
        require('@/assets/audio-loop.png') // 单曲循环
      ],
      popupVisible: false,
      options: {
        loop:true,
        pagination: false,
        currentPage: 0
      },
      list: [],
      playHistory: {},
      needUpPlay: true
    }
  },
  watch: {
    progress(value) {
      this.currentTime = (value/100)*this.duration
    },
    currentPlay() {
      this.needUpPlay = true
      this.drawImg()
    }
  },
  created () {
    this.list = this.audiolist
    var query = this.$route.query
    if(query.hasOwnProperty('index')){
      this.currentPlay = query.index
      this.options.currentPage = this.currentPlay
    }
    this.resetPlayHistoryInfo()
  },
  beforeDestroy() {
    this.destory()
  },
  mounted() {
    this.drawImg()
    this.setHistoryEndTime('')
  },
  methods: {
    drawImg() {
      this.$refs.glass.$emit('draw', this.list[this.currentPlay].cover_url_small)
    },
    menueClick(key){
      this.popupVisible = false
      this.$refs.slider.$emit('slideTo', key)
    },
    canplay(){
      this.setHistoryEndTime('canplay')
      this.duration = this.$refs.audio.duration
      this.progress = this.duration == 0? 0 : Math.floor((this.$refs.audio.currentTime/this.duration)*100)
      if(this.audioType !== 0){
        this.audioType = 2
        this.$refs.audio.play()
      }
    },
    changeLoop() {
      this.loopType = (this.loopType+1)%this.loopMap.length
    },
    play(index) {
      this.isSpin = true
      if(index == this.currentPlay){
        if(this.audioType == 0){
          this.audioType = 2
          this.$refs.audio.play()
          this.reportPlayNum();
          this.setPlayHistory()
        }
        return
      }
      // 判断是否付费
      if(!this.list[index].hasOwnProperty('track_source') || !this.list[index].track_source){
        sessionStorage.setItem("showPayHandle", 1)
        if(inBaiduBrowser()){
          this.$router.replace({path: '/play', query:{id:this.list[0].albumid}})
        }else{
          this.$router.go(-1)
        }
        return
      }
      // 切换音频
      this.destory()
      this.currentPlay = index
      this.setDTitle(this.list[index].track_title)
      this.audioType = 2
      this.isSpin = true
      this.$nextTick(()=>{
        this.$refs.audio.load()
      })
    },
    pause() {
      this.isSpin = false
      this.$refs.audio.pause()
      this.audioType = 0
    },
    pre() {
      this.$refs.slider.$emit('slidePre')
    },
    next(play) {
      this.$refs.slider.$emit('slideNext')
    },
    slide(data) {
      if(data.currentPage >= this.list.length || data.direction ==''){
        return
      }
      this.play(Number(data.currentPage))
    },
    destory(){
      this.pause()
      this.progress = 0
      // this.duration = 0
    },
    loadstart(){
      if(this.audioType != 0){
        this.audioType = 1
      }
    },
    waiting() {
      if(this.audioType != 0){
        this.audioType = 1
      }
    },
    end() {
      this.destory()
      if(this.loopType === 1){
        this.play(this.currentPlay)
        return
      }
      this.next(-1)
    },
    timeupdate(info) {
      if(!this.isFast){
        this.currentTime = this.$refs.audio.currentTime
        this.progress = this.duration == 0? 0 : Math.floor((this.currentTime/this.duration)*100)
        this.setPlayHistory()
      }
    },
    progressStart() {
      this.isFast = true
    },
    progressChange(value) {
      this.$refs.audio.currentTime = this.currentTime
      this.isFast = false
    },
    setDTitle(title) {
      // 设置title
      document.title = title
    },
    setPlayHistory(){
      const info = this.list[this.currentPlay]
      addHistory(info.albumid, info.albumname, info.cover_url_small, this.currentPlay, info.track_title, this.duration, this.currentTime)
    },
    resetPlayHistoryInfo() {
      if(this.list && this.list.length>0){
        this.playHistory = getHistoryForId(this.list[0].albumid)
      }else{
        this.playHistory = {}
      }
    },
    setHistoryEndTime(event){
      if(isAndroidOrIos() != 'ios' || event == 'canplay') {
        if(this.playHistory&&this.playHistory.hasOwnProperty('playid')&&this.currentPlay == this.playHistory.playid){
          this.$refs.audio.currentTime = this.playHistory.remainTime
        }
        if(this.playHistory&&this.playHistory.hasOwnProperty('albumid')){
          deleteHistory(this.playHistory.albumid)
        }
        this.playHistory = {}
      }
    },
    reportPlayNum(){
      if(this.needUpPlay){
        const info = this.list[this.currentPlay]
        report(info.id, info.albumid)
      }
      this.needUpPlay = false
    },
    formatTime,
    substring
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.audio-container{
  overflow: hidden;
  position: relative;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  .fuzzy{
    position:absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #1a1b3e;
    &::after{
      content: '';
      position:absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: #0000001f;
      opacity:1;
    }
  }
  .audio-content{
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .header{
      color: #fff;
      padding: 6px 0;
      font-size: 18px;
    }
    .content{
      position: relative;
      flex: 1;
      img{
        pointer-events: none;
      }
      .joystick{
        width: 26.13vw;
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 2;
        transform:rotate(-20deg);
        transform-origin: 16px 16px;
        transition: transform 500ms ease-out;
        &.start{
          transform:rotate(0deg);
          transition: transform 500ms ease-in;
        }
      }
      .record{
        text-align: center;
        min-width: 178px;
        min-height: 178px;
        width: 47.46vw;
        height: 47.46vw;
        padding: 12vw;
        margin-top: 22.13vw;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('~@/assets/audio-bg.png') center;
        background-size: contain;
        background-repeat:no-repeat;
        &.start{
          animation:turn 20s linear 500ms infinite;
        }
        img{
          min-width: inherit;
          min-height: inherit;
          width: inherit;
          height: inherit;
          display: inline-block;
          border-radius: 50%;
        }
      }
    }
    .panel{
      color: #fff;
      .mt-range{
        margin: 0 23px;
      }
      .time{
        display: flex;
        align-items: center;
        justify-content:space-between;
        padding: 0 23px;
        font-size: 12px;
      }
      .btn{
        display: flex;
        align-items: center;
        justify-content:space-around;
        padding: 0 16px;
        padding-bottom: 44px;
        .loop{
          width: 6.9vw;
        }
        .pre{
          width: 8vw;
        }
        .play{
          width: 15.4vw;
          &.loading{
            animation:turn 1s linear infinite;
          }
        }
        .next{
          width: 8vw;
        }
        .menu{
          width: 6.9vw;
        }
      }
    }
  }
  .mint-popup{
    background: inherit;
  }
  .popup-container{
    width: 100vw;
    background:rgba(0,0,0,0.5);
    text-align: left;
    color: #eee;
    height: 72vh;
    display: flex;
    flex-direction: column;
    .item-header{
      font-size: 18px;
      padding: 16px;
      border-bottom: 1px rgba(238, 238, 238, 0.1) solid;
    }
    .item-list{
      flex: 1;
      overflow-y: auto;
    }
    .item{
      padding: 16px 16px 16px 0;
      margin-left: 16px;
      border-bottom: solid 1px rgba(238, 238, 238, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.playing{
        color: rgb(29, 253, 186);
      }
      img{
        width: 16px;
        height: 16px;
      }
    }
    .item-foot{
      text-align: center;
      padding: 21px 0;
      border-top: rgba(255, 255, 255, 0.1) 1px solid;
      margin-top: 6px;
    }
  }
}
@keyframes turn{
  0%{transform:rotate(0deg);}
  25%{transform:rotate(90deg);}
  50%{transform:rotate(180deg);}
  75%{transform:rotate(270deg);}
  100%{transform:rotate(360deg);}
}
</style>
